import React from "react";
import { Rocket, Check } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useConfig, goToCheckout } from "@/lib/useConfig";

export function UpgradeModal({ open, onOpenChange }) {
  const { config } = useConfig();

  const handleUnlock = () => {
    const ok = goToCheckout(config, "upgrade-modal");
    if (!ok) {
      toast.info("Checkout em configuração", {
        description:
          "O link de compra ainda será configurado. Defina a variável CHECKOUT_URL para ativar o pagamento.",
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="upgrade-modal"
        className="glass max-w-md rounded-3xl border-white/10 text-center"
      >
        <DialogHeader>
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500/20 to-cyan-400/20 text-violet-300">
            <Rocket className="h-7 w-7" />
          </div>
          <DialogTitle className="mt-4 font-display text-2xl font-extrabold text-white">
            Seu teste gratuito terminou 🚀
          </DialogTitle>
          <DialogDescription className="sr-only">
            Seu teste gratuito do Pronto.AI terminou. Desbloqueie o acesso completo por 1 ano por R$ 4,99.
          </DialogDescription>
        </DialogHeader>

        <p className="text-sm text-slate-300">Você já experimentou o Pronto.AI.</p>
        <p className="text-sm text-slate-300">Desbloqueie o acesso completo por apenas:</p>

        <div className="my-2 flex items-end justify-center gap-3">
          <span className="font-display text-xl font-semibold text-slate-500 line-through">
            R$ 19,99
          </span>
          <span className="gradient-text font-display text-5xl font-extrabold">R$ 4,99</span>
        </div>

        <div className="mx-auto inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-4 py-1.5 text-sm font-semibold text-emerald-400">
          <Check className="h-4 w-4" /> 1 ano de acesso
        </div>

        <Button
          onClick={handleUnlock}
          data-testid="unlock-now-button"
          className="mt-4 h-auto w-full rounded-full bg-emerald-500 py-4 text-base font-bold text-slate-950 shadow-[0_0_30px_rgba(16,185,129,0.35)] transition-all hover:bg-emerald-400 hover:scale-[1.01] active:scale-95"
        >
          DESBLOQUEAR AGORA
        </Button>

        <p className="mt-1 text-xs text-slate-500">
          Pagamento único de R$ 4,99 por 1 ano de acesso. Sem mensalidade.
        </p>
      </DialogContent>
    </Dialog>
  );
}
